function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40 69C56.0163 69 69 56.0163 69 40C69 23.9837 56.0163 11 40 11C23.9837 11 11 23.9837 11 40C11 56.0163 23.9837 69 40 69ZM40 76C59.8823 76 76 59.8823 76 40C76 20.1177 59.8823 4 40 4C20.1177 4 4 20.1177 4 40C4 59.8823 20.1177 76 40 76Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.3697 61.5594C31.9698 61.5594 30.2186 60.1008 31.8948 53.7074L34.6434 42.3642C35.1196 40.5493 35.1984 39.8218 34.6434 39.8218C33.9272 39.8218 30.8111 41.0743 28.9737 42.3117L27.7775 40.3506C33.6084 35.4796 40.3131 32.6222 43.1817 32.6222C45.5816 32.6222 45.9791 35.4571 44.7829 39.8218L41.633 51.7462C41.0743 53.8536 41.3143 54.5811 41.873 54.5811C42.593 54.5811 44.9479 53.7111 47.2652 51.885L48.6227 53.7074C42.9492 59.3771 36.7658 61.5594 34.3697 61.5594Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M43.3617 16.9968C46.8715 16.9968 47.9027 19.0329 47.9027 21.3615C47.9027 24.2676 45.5778 26.9562 41.6068 26.9562C38.2845 26.9562 36.702 25.2876 36.7995 22.524C36.7995 20.1954 38.7457 16.9968 43.3617 16.9968Z"
});

function SvgIconTips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTips);
export default __webpack_public_path__ + "static/media/IconTips.24380978.svg";
export { ForwardRef as ReactComponent };